module.exports = __webpack_public_path__ + "static/img/car_new_mg_ep_plus.3c1b6834.png";